import * as React from "react";
import { NonRxProductCTA } from "../../../../../../../../components/CTAs/NonRxProductCTA/modules/EcommContent/components/CTAs/NonRxProductCTA/NonRxProductCTA.js";
import { useProductData } from "../../../../../../../../../../context/context/product-context-hooks.js";
import { getProductTealiumDescription } from "../../../../../../../../../../utils/utils/get-product-tealium-description.js";
const ReadyReaderCTA = () => {
  const {
    activeVariant: { channelAvailability, sku },
    routes,
    product
  } = useProductData();
  const handleConversionEvent = React.useCallback(() => {
  }, []);
  const onAddToCartSuccess = React.useCallback(() => {
  }, []);
  const productAction = channelAvailability === "ONLINE" ? "ADD_TO_CART" : "ADD_TO_CART_UNAVAILABLE";
  return /* @__PURE__ */ React.createElement(
    NonRxProductCTA,
    {
      storesRoute: routes.stores ?? "",
      action: productAction,
      handleConversionEvent,
      addToCartConfig: {
        activeSku: sku,
        onSuccess: onAddToCartSuccess
      },
      "data-element-id": "Prod_AddCart",
      "data-description": getProductTealiumDescription(product.name, sku)
    }
  );
};
export {
  ReadyReaderCTA
};
//# sourceMappingURL=ReadyReaderCTA.js.map
